if (!customElements.get('simp-product-choice')) {
  customElements.define('simp-product-choice', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        const row = this.querySelector('.simp-choice__items--grid');
        const current = row?.querySelector('[aria-current="page"]');
        if (!row || !current || row.scrollWidth <= row.clientWidth) return;
        row.scrollLeft = current.offsetLeft - row.offsetLeft - (row.clientWidth - current.offsetWidth) / 2;
      });
    }
  });
}
